export const seasonMap = {
	'SPRING': 'Spring',
	'SUMMER': 'Summer',
	'AUTUMN': 'Autumn',
	'WINTER': 'Winter',
	'EMPTY': ''
};